import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy misspelled URL saved in homepage content — permanently forward to the catalog.
export const Route = createFileRoute("/fragrences")({
  beforeLoad: () => {
    throw redirect({ to: "/fragrances", statusCode: 301 });
  },
});
